<template>
  <div class="wrapper" v-if="doc_id">
    <div class="close_btn_wrapper">
      <el-button size="mini" type="danger" plain @click="hide()">关闭</el-button>
    </div>

    <div class="inner_wrapper">
      <div style="margin-right: 2em;flex-grow: 1" v-loading="text_loading">
        <div>
          <label for="doc_id">_id:</label>
          <input id="doc_id" v-model="doc_id" style="width: 20em" />
          <el-button size="mini" @click="onLoadDocClick(doc_id)">加载</el-button>
        </div>

        <div v-if="documentData">
          <div>
            <label for="keywords">附加关键词</label>
            <textarea v-model="keywords" id="keywords" placeholder="关键词"></textarea>
          </div>
          <div class="origin_text" v-if="documentData.data">
            <div v-for="obj in documentData.data.项目经历">
              <div style="font-weight: bold">项目:{{ obj.项目名称 }}</div>
              <div v-html="renderLine(obj.项目职责)"></div>
              <div v-html="renderLine(obj.项目描述)"></div>
            </div>
            <div v-for="obj in documentData.data.工作经历">
              <div style="font-weight: bold">公司:{{ obj.公司 }}</div>
              <div v-html="renderLine(obj.工作职责)"></div>
              <div v-html="renderLine(obj.工作业绩)"></div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div>
          <label for="topn">topn</label>
          <input v-model="topn" id="topn" />
        </div>

        <el-button size="mini" @click="dopost('predict')">Predict</el-button>

        <div v-if="predictResult && predictResult.标签预测">
          <h2>建议职能模块:</h2>
          <div v-for="name in predictResult.标签预测.建议职能模块">
            <el-button size="mini" @click="onInterpretClick(name)">{{ name }}</el-button>
          </div>
          <h2>建议行业:</h2>
          <div>{{ predictResult.标签预测.建议行业.join(',') }}</div>
        </div>

        <h1>Interpret</h1>
        <div>
          <label for="topk">topk</label>
          <input v-model="topk" id="topk" />
        </div>

        <div v-if="interpretResult">
          <h2>{{ interpretResult.class }}</h2>

          <div>predict_proba:{{ interpretResult.predict_proba }}</div>
          <div v-for="i in interpretResult.words.length">
            {{ i - 1 }} &nbsp; {{ interpretResult.words[i - 1] }} &nbsp; {{ interpretResult.log_probas[i - 1] }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
textarea {
  width: 100%;
  height: 5em;
}

.origin_text > div {
  margin-top: 1em;
}

.wrapper {
  /* border: 1px blue solid; */
  display: flex;
  flex-direction: column;

  position: fixed;
  left: 0;
  right: 0;
  top: 50px;
  bottom: 0;
  background-color: white;
  padding: 5px;
}

.inner_wrapper {
  flex-grow: 1;
  /* border: 1px red solid; */
  display: flex;
  overflow-y: scroll;
  max-height: 100%;
}

.close_btn_wrapper {
  text-align: center;
  margin-bottom: 10px;
}
</style>

<script>
// const tmpObj = require('./jsonObject.json')

export default {
  props: {
  },
  data() {
    return {
      documentData: null,
      interpretResult: null,
      predictResult: null,
      topn: 5,
      topk: 10,
      label: null,
      keywords: null,
      text_loading: false,
      doc_id: null,
    }
  },
  computed: {},
  methods: {
    async hide() {
      this.doc_id = null
    },
    async show(doc_id, label) {
      this.doc_id = doc_id
      this.label = label
      if (!doc_id) {
        alert('doc id is null')
        return
      }
      console.log('label:', label, 'doc_id:', doc_id)

      //加载文档
      console.log('查询文档:' + this.doc_id)
      const data = await this.getDocById(this.doc_id)
      if (!data) {
        alert('未能查询到相关文档')
        return
      }
      this.documentData = data
      console.log('得到文档数据', this.documentData)
      this.$forceUpdate()
      // 预测
      await this.dopost('predict')
      //解释
      if (this.label) {
        await this.dopost('interprete')
      }
    },
    async onLoadDocClick(doc_id) {
      if (!doc_id) {
        alert('doc_id不能为空')
        return
      }
      const data = await this.getDocById(doc_id)
      if (!data) {
        alert('未能查询到相关文档')
        return
      }
      this.keywords = null
      this.documentData = data
      //然后predict
      await this.dopost('predict')
    },
    async getDocById(doc_id) {
      const re = await window.app.service('misc').getDocById({ doc_id: doc_id })
      return re.data
    },
    async dopost(action_name) {
      try {
        this.text_loading = true
        await this.dopost_unsafe(action_name)
      } catch (e) {
        alert(e)
      } finally {
        this.text_loading = false
      }
    },
    async dopost_unsafe(command) {
      //1.检验正确性
      if (['predict', 'interprete'].indexOf(command) < 0) {
        alert('错误的指令:' + command)
        return
      }
      const isPredict = command === 'predict'

      let jsonObject = JSON.parse(JSON.stringify(this.documentData))
      if (this.keywords) {
        //补充新的关键词
        const arr = jsonObject.data.项目经历 || []
        arr.push({
          项目描述: this.keywords,
        })
        jsonObject.data.项目经历 = arr
      }

      //4.执行
      const form = {
        label: this.label,
        topn: this.topn,
        topk: this.topk,
        jsonObject: jsonObject,
        command: command,
      }
      let re
      try {
        re = await window.app.service('misc').predictOrInterprete(form)
      } catch (e) {
        throw new Error(command + '执行失败:' + e)
      }
      if (re.status !== 'success') {
        throw new Error('执行失败:' + JSON.stringify(re))
      }

      //predict接口,虽然status为success,但仍有可能附带error_message,如: "错误:简历没有解析内容。"
      if (re.data.error_message) {
        throw new Error('错误:' + re.data.error_message)
      }

      if (isPredict) {
        this.predictResult = re.data
      } else {
        this.interpretResult = re.data[0]
      }

      if (isPredict) {
        console.log('predictResult', this.predictResult)
      } else {
        console.log('interpretResult', this.interpretResult)
      }

      this.$forceUpdate()
    },
    renderLine(text) {
      if (this.interpretResult && this.interpretResult.words) {
        const words = this.interpretResult.words
        for (let w of words) {
          w = w.replace(/\s/g, '')
          text = text.replace(new RegExp(w, 'g'), `<span style="background-color: blanchedalmond;">${w}</span>`)
        }
        return `<div>${text}</div>`
      }
      return text
    },
    onInterpretClick(name) {
      this.label = name
      this.dopost('interprete')
    },
  },
}
</script>
